import { render, staticRenderFns } from "./RiskControlOperator.vue?vue&type=template&id=3043e1ee&scoped=true"
import script from "./RiskControlOperator.vue?vue&type=script&lang=js"
export * from "./RiskControlOperator.vue?vue&type=script&lang=js"
import style0 from "./RiskControlOperator.vue?vue&type=style&index=0&id=3043e1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3043e1ee",
  null
  
)

export default component.exports